/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  type PayloadAction,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { type RootState } from "../../store";
import { API } from "../../../api/Api";
import {
  type PaginationParams,
  type PaginationResponse,
} from "../midservice/midserviceTypes";
import { message } from "antd";
import {
  type PacketConfigurationRequestType,
  type PacketConfigurationResponseType,
} from "./PacketConfigurationTypes";
// import { TelemetryAPI } from "../../../api/TelemetryApi";

export interface ManageUsersState {
  configurationsList: PaginationResponse<PacketConfigurationResponseType[]>;
  // currentPage: number;
  loading: boolean;
  currentPage: number;
  currentConfiguration?: PacketConfigurationResponseType;
  // selectedInstances: string[];
  // selectedInstancesTouched: boolean;
}

const initialState: ManageUsersState = {
  configurationsList: {
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecord: 0,
    content: [],
  },
  loading: false,
  currentPage: 1,
  // selectedInstances: [],
};

export const getConfigurationsListAsync = createAsyncThunk(
  "manageUsers/getConfigurationsList",
  async (paginationParams: PaginationParams) => {
    console.log("getUsers");
    const response = await API.getConfigurationsList(paginationParams);
    console.log("responseresponseresponse", response);
    return response.data;
  },
);

export const retrievePacketConfigurationAsync = createAsyncThunk(
  "manageUsers/retrievePacketConfigurationAsync",
  async (packetConfigurationId: number, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.retrievePacketConfiguration(
        packetConfigurationId,
      );
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const deletePacketConfigurationAsync = createAsyncThunk(
  "manageUsers/deletePacketConfigurationAsync",
  async (packetConfigurationId: number, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.deletePacketConfiguration(
        packetConfigurationId,
      );
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const deployPacketConfigurationAsync = createAsyncThunk(
  "manageUsers/deployPacketConfigurationAsync",
  async (packetConfigurationId: number, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.deployPacketConfiguration(
        packetConfigurationId,
      );
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const createPacketConfigurationAsync = createAsyncThunk(
  "manageUsers/createPacketConfigurationAsync",
  async (
    createUserParams: PacketConfigurationRequestType,
    { rejectWithValue },
  ) => {
    console.log("getUsers");
    try {
      const response = await API.createPacketConfiguration(createUserParams);
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const updatePacketConfigurationAsync = createAsyncThunk(
  "manageUsers/updatePacketConfigurationAsync",
  async (
    updateUserParams: PacketConfigurationRequestType,
    { rejectWithValue },
  ) => {
    console.log("getUsers");
    try {
      const response = await API.updatePacketConfiguration(updateUserParams);
      console.log("responseresponseresponse", response);
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

// export const deleteUserAsync = createAsyncThunk(
//   "manageUsers/deleteUserAsync",
//   async (userId: number, { rejectWithValue }) => {
//     console.log("getUsers");
//     try {
//       const response = await API.deleteUser(userId);
//       console.log("getNetworks resp", response);
//       return response.data;
//     } catch (error: any) {
//       console.log(error);
//       if (error?.response?.data?.detail != null) {
//         return rejectWithValue(error.response.data.detail);
//       } else {
//         return rejectWithValue(error.message);
//       }
//     }
//   },
// );

// // interface NetworkRecord {
// //   domain: string
// //   networks:
// // }

// export const getAvailableZonesAsync = createAsyncThunk(
//   "manageUsers/getAvailableZonesAsync",
//   async (_, { rejectWithValue }) => {
//     console.log("getUsers");
//     try {
//       const response = await API.getAvailableZones();
//       console.log("getNetworks resp", response);
//       return response.data;
//     } catch (error: any) {
//       console.log(error);
//       if (error?.response?.data?.detail != null) {
//         return rejectWithValue(error.response.data.detail);
//       } else {
//         return rejectWithValue(error.message);
//       }
//     }
//   },
// );

// export const getAvailableRolesAsync = createAsyncThunk(
//   "manageUsers/getAvailableRoles",
//   async (_, { rejectWithValue }) => {
//     console.log("getUsers");
//     try {
//       const response = await API.getAvailableRoles();
//       console.log("getNetworks resp", response);
//       return response.data;
//     } catch (error: any) {
//       console.log(error);
//       if (error?.response?.data?.detail != null) {
//         return rejectWithValue(error.response.data.detail);
//       } else {
//         return rejectWithValue(error.message);
//       }
//     }
//   },
// );

export const manageUsersSlice = createSlice({
  name: "manageUsers",
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setCurrentConfiguration: (
      state,
      action: PayloadAction<PacketConfigurationResponseType | undefined>,
    ) => {
      state.currentConfiguration = action.payload;
    },
    // setSelectedInstances: (
    //   state,
    //   action: PayloadAction<{ selectedItems: string[] }>,
    // ) => {
    //   state.selectedInstances = action.payload.selectedItems;
    // },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getConfigurationsListAsync.pending, (state) => {})
      .addCase(getConfigurationsListAsync.fulfilled, (state, action) => {
        state.configurationsList = action.payload;
        state.configurationsList.content = state.configurationsList.content.map(
          (v: any) => ({
            ...v,
            key: v.id,
          }),
        );
      })
      .addCase(getConfigurationsListAsync.rejected, (state, action) => {
        console.log("actionaction", action);
      })
      .addCase(createPacketConfigurationAsync.pending, (state) => {})
      .addCase(createPacketConfigurationAsync.fulfilled, (state, action) => {
        state.currentConfiguration = action.payload;
        message.success("Конфигурация создана");
      })
      .addCase(createPacketConfigurationAsync.rejected, (state, action) => {
        console.log("actionaction", action);
        message.error(action.error.message);
      })
      .addCase(updatePacketConfigurationAsync.pending, (state) => {})
      .addCase(updatePacketConfigurationAsync.fulfilled, (state, action) => {
        state.currentConfiguration = action.payload;
        message.success("Сохранено");
      })
      .addCase(updatePacketConfigurationAsync.rejected, (state, action) => {
        console.log("actionaction", action);
        message.error(action.error.message);
      })

      .addCase(retrievePacketConfigurationAsync.pending, (state) => {})
      .addCase(retrievePacketConfigurationAsync.fulfilled, (state, action) => {
        state.currentConfiguration = action.payload;
      })
      .addCase(retrievePacketConfigurationAsync.rejected, (state, action) => {
        console.log("actionaction", action);
      })
      .addCase(deployPacketConfigurationAsync.pending, (state) => {})
      .addCase(deployPacketConfigurationAsync.fulfilled, (state, action) => {
        message.info("Конфигарация применяется ...");
      })
      .addCase(deployPacketConfigurationAsync.rejected, (state, action) => {
        console.log("actionaction", action);
      })
      .addCase(deletePacketConfigurationAsync.fulfilled, (state, action) => {
        state.configurationsList.content =
          state.configurationsList.content.filter(
            (conf) => conf.id !== action.payload,
          );
        message.success("Конфигарация удалена");
      });
  },
});

export const selectConfigurationsList = (
  state: RootState,
): PaginationResponse<PacketConfigurationResponseType[]> =>
  state.configuration.configurationsList;

export const selectConfigurationCurrentPage = (state: RootState): number =>
  state.configuration.currentPage;

// export const selectSelectedInstances = (state: RootState): string[] =>
//   state.configuration.selectedInstances;

export const selectCurrentConfiguration = (
  state: RootState,
): PacketConfigurationResponseType | undefined =>
  state.configuration.currentConfiguration;

export const { setCurrentPage, setCurrentConfiguration } =
  manageUsersSlice.actions;

export default manageUsersSlice.reducer;
